import { render, staticRenderFns } from "./ParticipantesListAddNew.vue?vue&type=template&id=672836aa&"
import script from "./ParticipantesListAddNew.vue?vue&type=script&lang=js&"
export * from "./ParticipantesListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantesListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports